import React from 'react';
import {connectI18n, connectEvent, connectEventFormDrafts} from '../../../connects';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Screen from '../../Screen';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Scrollable from '../../../elements/Scrollable';
import Link from '../../../elements/Link';
import moment from 'moment';
import '../EventForm.scss';

class EventFormDrafts extends React.Component {
    render() {
        let {event, i18n, formDrafts, forms} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event}>{forms[0].draftscreen_title || i18n['label.your-requests']}</TopBarEvent>
                    <hr />
                </div>
            ),
            footer = (
                <div className="content">
                    <Link href={"../create"} className="btn" style={event._local.styles.button}>
                        {forms[0].button_title}
                    </Link>
                </div>
            );

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    <div className="content">
                        {formDrafts.length ? (
                            <div>
                                <h2>{i18n['label.pending']}</h2>
                                <ul className="EventForm--FormList">
                                    {formDrafts.map(draft => (
                                        <li key={draft.UID}>
                                            <Link href={['..', draft.formId, draft.UID].join('/')}>
                                                {this.props.summaryQuestions[draft.formId].map((question, i) => (
                                                    <p key={question.id} className={'text' + (i == 0 ? ' main' : '')}>
                                                        {(draft.answers[question.id] || []).join()}
                                                    </p>
                                                ))}
                                                <p className="text ">{moment(draft.createdAt).format('lll')}</p>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedScreen = compose(
    connectEvent,
    connectI18n,
    connectEventFormDrafts,
    connect((state, props) => ({
        summaryQuestions: props.forms.reduce((formSummaryQuestions, form) => {
            formSummaryQuestions[form.id] = _(form.groups)
                .map(group => group.questions)
                .flatten()
                .compact()
                .filter(question => question.in_summary)
                .value();
            return formSummaryQuestions;
        }, {}),
    }))
)(EventFormDrafts);

export default props => <ConnectedScreen {...props.match.params} />;
